import "./FooterStyle.css"

const Footer = () =>{
    return(
        <div className="footer">
            <div className="top">
                <div>
                    <h1>ITO</h1>
                </div>
                <div>
                    <a href="/"><i class="fa-brands fa-square-facebook"></i></a>
                    <a href="/"><i class="fa-brands fa-square-instagram"></i></a>
                    <a href="/"><i class="fa-brands fa-linkedin"></i></a>
                    <a href="/"><i class="fa-brands fa-square-twitter"></i></a>
                </div>
            </div>

            <div className="bottom">
                <div>
                    <h4>Sponsers</h4>
                    <a href="/">Crack Developers</a>
                    <a href="/">Duo Clicks</a>
                </div>
                <div>
                    <h4>Comunity</h4>
                    <a href="/">Instagram</a>
                    <a href="/">Facebook</a>
                    <a href="/">Linkedin</a>
                    <a href="/">Twitter</a>
                </div>
                <div>
                    <h4>Avanues</h4>
                    <a href="/">Club</a>
                    <a href="/">International</a>
                    <a href="/">Professional</a>
                    <a href="/">Women Empoverment</a>
                    <a href="/">Comunity</a>
                </div>
                <div>
                    <h4>Help</h4>
                    <a href="/">Support</a>
                    <a href="/">Contact us</a>
                </div>
            </div>
        </div>
    )
}

export default Footer;